import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';


export function* getProductDetails(params) {
    try {
        let response = '';
        if (params.url) {
            response = yield call(() => getRequest(params.url));
        } else {
            if (params.filter) {
                response = yield call(() => getRequest('universal-products?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
            } else {
                response = yield call(() => getRequest('universal-products'));
            }
        }

        yield put({
            type: actions.PRODUCT_DETAILS_SUCCESS,
            payload: response.data,
            export: params?.export,
            data: params?.data,
            selected: params?.selected,
            extension: params?.extension
        });
    } catch (error) {
        yield put({ type: actions.PRODUCT_DETAILS_FAILURE });
        return error;
    }
}

export function* getCatalogueDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('catalogues?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('catalogues'));
        }
        yield put({
            type: actions.CATALOGUE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CATALOGUE_DETAILS_FAILURE });
        return error;
    }
}


export function* getCategoryDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('product-categories?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('product-categories'));
        }
        yield put({
            type: actions.CATEGORY_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.CATEGORY_DETAILS_FAILURE });
        return error;
    }
}

export function* getProductCategoryDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('categoriesForClientProduct?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('categoriesForClientProduct'));
        }
        yield put({
            type: actions.CLIENT_PRODUCT_CATEGORY_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.CLIENT_PRODUCT_CATEGORY_DETAILS_FAILURE });
        return error;
    }
}


export function* getProductCatalogueDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('cataloguesForClientProduct?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('cataloguesForClientProduct'));
        }
        yield put({
            type: actions.CLIENT_PRODUCT_CATALOGUE_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.CLIENT_PRODUCT_CATALOGUE_DETAILS_FAILURE });
        return error;
    }
}

export function* getBrandDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('brands?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('brands'));
        }
        yield put({
            type: actions.BRAND_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.BRAND_DETAILS_FAILURE });
        return error;
    }
}

export function* getProviderDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('subscriptionProviders?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('subscriptionProviders'));
        }
        yield put({
            type: actions.PROVIDER_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PROVIDER_DETAILS_FAILURE });
        return error;
    }
}

export function* getPlanDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.PLAN_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PLAN_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_ADMIN_PRODUCT_DETAILS_SUCCESS,
    });
}


export default function* younoteAdminProductSaga() {
    yield all([
        takeEvery(actions.PRODUCT_DETAILS_START, getProductDetails),
        takeEvery(actions.CATALOGUE_DETAILS_START, getCatalogueDetails),
        takeEvery(actions.CATEGORY_DETAILS_START, getCategoryDetails),
        takeEvery(actions.CLIENT_PRODUCT_CATEGORY_DETAILS_START, getProductCategoryDetails),
        takeEvery(actions.CLIENT_PRODUCT_CATALOGUE_DETAILS_START, getProductCatalogueDetails),
        takeEvery(actions.BRAND_DETAILS_START, getBrandDetails),
        takeEvery(actions.PROVIDER_DETAILS_START, getProviderDetails),
        takeEvery(actions.PLAN_DETAILS_START, getPlanDetails),
        takeEvery(actions.CLEAR_ADMIN_PRODUCT_DETAILS_START, getClearDetails)
    ]);
}